import { getAcTypeData } from "../../helpers/AccountTypes";
import { IconJsxer } from "../../helpers/IconHelper";
import ProfilePic, { PROFILE_PIC_SIZES } from "../../components/ProfilePic/ProfilePic";

const ListedUser = (props) => {
    const { user, editUserFunc } = props;
    const acTypeData = getAcTypeData(user.acType);

    return (
        <div className="fl-row list-view-content list-view-content-list-item cursor-pointer">
            <div className="list-view-data-block">
                <div className="fl-row compact">
                    <ProfilePic size={PROFILE_PIC_SIZES.small} className="pp-style" user={user} />
                    <span className="user-name">{user.firstName} {user.lastName}</span>
                </div>
            </div>
            <div className="list-view-data-block">
                <span className="email">{user.email}</span>
            </div>
            <div className="list-view-data-block">
                {user.isTwitch && user.name && user.name !== "TWITCH_LOCAL" ? (
                    <a href={'https://www.twitch.tv/'+user.name} target='_blank' rel="noopener noreferrer">{user.name}</a>
                ) : (
                    <span className="light-text">-</span>
                )}
            </div>
            <div className="list-view-data-block">
                <span className="user-type">{acTypeData.shortName}</span>
            </div>
            <div className="list-view-data-block">
                <div className="tight" title="Edit user details" onClick={(event) => editUserFunc(event, user._id, user)}>
                    {IconJsxer.GetIcon(IconJsxer.ICONS.addressCard, IconJsxer.ICON_STYLES.listIcon, 'icons')}
                </div>
            </div>
        </div>
    );
}

export default ListedUser;
